// extracted by mini-css-extract-plugin
export default {"logo":"logo","logo-img":"logo-img","logo-text":"logo-text"};
    if(module.hot) {
      // 1790857659207
      var cssReload = require("/home/vsts/work/1/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  